{
  "authLayout": {
    "link": "Terms of service",
    "link2": "Privacy policy",
    "link3": "Operating company"
  },
  "forgotPasswordView": {
    "enqueueSnackbar": "A verification code was sent to your email.",
    "text": "An error occurred.",
    "enqueueSnackbar2": "Password reset",
    "text2": "Forgot your password?",
    "text3": "Enter the email address registered with {{serviceName}} to reset your password.",
    "text4": "Enter the verification code sent to your email and a new password.",
    "label": "Email address",
    "placeholder": "Enter email address",
    "button": "Send request",
    "label2": "Verification code",
    "placeholder2": "Enter verification code",
    "label3": "New password",
    "placeholder3": "Enter new password",
    "button2": "Reset password",
    "link": "Back to sign-in"
  },
  "loginView": {
    "text": "Sign in",
    "text2": "Sign in to Rabbit Live",
    "text3": "Sign in to JIZAIPAD",
    "getErrorMessage": "An error occurred.",
    "getErrorMessage2": "The verification code is incorrect.",
    "getErrorMessage3": "The password couldn't be set.",
    "label": "Email address",
    "placeholder": "Enter email address",
    "label2": "Password",
    "placeholder2": "Enter password",
    "link": "Forgot your password?",
    "button": "Sign in",
    "text4": "or",
    "button2": "Sign in with an external account (SSO)",
    "text5": "Enter the verification code.",
    "label3": "Verification code",
    "placeholder3": "Enter verification code",
    "button3": "Verify"
  },
  "newPasswordRegistrationForm": {
    "text": "Enter your last name.",
    "text2": "Last name must be 50 characters or fewer.",
    "text3": "Enter your first name.",
    "text4": "First name must be 50 characters or fewer.",
    "text5": "Enter your last name (phonetic).",
    "text6": "Last name (phonetic) must contain only katakana.",
    "text7": "Last name (phonetic) must be 50 characters or fewer.",
    "text8": "Enter your first name (phonetic).",
    "text9": "First name (phonetic) must contain only katakana.",
    "text10": "First name (phonetic) must be 50 characters or fewer.",
    "text11": "Enter a password.",
    "text12": "Enter the password confirmation.",
    "text13": "The passwords don't match.",
    "text14": "Set your account information and a new password.",
    "label": "Last name",
    "placeholder": "Enter last name",
    "label2": "First name",
    "placeholder2": "Enter first name",
    "label3": "Last name (phonetic)",
    "placeholder3": "Enter last name (phonetic)",
    "label4": "First name (phonetic)",
    "placeholder4": "Enter first name (phonetic)",
    "label5": "Password",
    "placeholder5": "Enter password",
    "label6": "Confirm password",
    "placeholder6": "Re-enter password",
    "ariaLabel": "Agree to the terms of service",
    "link": "Terms of service",
    "text15": " and ",
    "link2": "Privacy policy",
    "text16": " (I agree)"
  },
  "samlLoginFooter": {
    "link": "Terms of service",
    "link2": "Privacy policy",
    "link3": "Operating company"
  },
  "samlLoginForm": {
    "required": "Enter a tenant ID.",
    "matches": "Only letters, numbers, hyphens, and underscores can be used.",
    "message": "A network error occurred. Try again later.",
    "text": "A server error occurred. Try again later.",
    "text2": "Sign-in with an external account isn't available.",
    "text3": "SSO is disabled for this tenant.",
    "text4": "SSO is an optional feature for contracted tenants.",
    "label": "Tenant ID",
    "text5": "Sign in with an external account (SSO)",
    "text6": "SSO is an optional feature for contracted tenants",
    "link": "Back to standard sign-in"
  },
  "samlLoginTypography": {
    "text": "Sign in with an external account (SSO)"
  },
  "useNewPasswordRegistration": {
    "call": "The password was changed. Sign in again with the new password.",
    "error": "The password was changed, but the user information couldn't be retrieved. Sign in with the new password."
  }
}
